import { useEffect, useMemo, useState } from "react";

export default function useIsInViewport(ref: HTMLElement | undefined, threshold?: number) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const observer = useMemo(
    () =>
      new IntersectionObserver(([entry]) => setIsIntersecting(entry?.isIntersecting ?? false), {
        threshold,
      }),
    []
  );

  useEffect(() => {
    if (ref) {
      observer.observe(ref);
    }

    return () => {
      observer.disconnect();
    };
  }, [ref, observer]);

  return isIntersecting;
}
